import React from 'react';
import { ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const rows = [{
  label: '📘 The MenoReset System™ (6 Volumes, 60+ pages)',
  price: '$19'
}, {
  label: '🎁 Bonus #1: The Hormone-Balancing Elixirs',
  price: 'FREE'
}, {
  label: '🎁 Bonus #2: The 7-Day Meno-Detox Plan',
  price: 'FREE'
}, {
  label: '🎁 Bonus #3: The Meno-Apothecary Encyclopedia',
  price: 'FREE'
}, {
  label: '🛡️ 7-Day Money-Back Guarantee',
  price: 'INCLUDED'
}, {
  label: '♾️ Lifetime access & free updates',
  price: 'INCLUDED'
}];
const trust = [{
  icon: LockIcon,
  label: '100% Secure Payment'
}, {
  icon: ZapIcon,
  label: 'Instant Delivery'
}, {
  icon: ShieldCheckIcon,
  label: '7-Day Guarantee'
}, {
  icon: CreditCardIcon,
  label: 'Debit / Credit'
}];
export function ValueStack() {
  return <section id="value" aria-label="Offer summary" className="border-y border-grape/10 bg-white/70" data-id="element-187" data-mp="30wacdhef7o36">
      <div className="mx-auto max-w-2xl px-5 py-12 text-center" style={{
      paddingTop: "13px",
      paddingBottom: "25px"
    }} data-id="element-188" data-mp="35r7tzcprn5ro">
        <h2 className="font-display text-2xl font-black text-plum sm:text-4xl" data-id="element-189" data-mp="1og9z5yuii9y8">
          🚀 Start Reclaiming Your Vitality In 30 Days
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-sm text-plum/60" data-id="element-190" data-mp="235y3za1wjqqp">
          Cool down your body, sleep deeply, and protect your metabolism. One single payment,
          lifetime access, everything ready to start today.
        </p>

        <div className="mt-10 overflow-hidden rounded-2xl border border-grape/15 bg-cream text-left" data-id="element-191" data-mp="2c7p84agsnpig">
          <div className="flex items-center justify-between border-b border-grape/10 px-5 py-3 text-xs font-bold uppercase tracking-wide text-plum/55" data-id="element-192" data-mp="286lr3kn0fnfn">
            <span data-id="element-193" data-mp="2h68wehiv1ddz">What's included</span>
            <span data-id="element-194" data-mp="2h34k0wv8rbc8">Price</span>
          </div>
          {rows.map(r => <div key={r.label} className="flex items-center justify-between gap-4 border-b border-grape/10 px-5 py-3.5 text-sm" data-id="element-195" data-mp="rqsmv110xpnk">
              <span className="text-plum/80" data-id="element-196" data-mp="mt0y2fvoejnl">{r.label}</span>
              <span className={r.price.startsWith('$') ? 'shrink-0 font-bold text-plum' : 'shrink-0 font-bold text-grape'} data-id="element-197" data-mp="2mu7gruhdmhq3">
                {r.price}
              </span>
            </div>)}
          <div className="flex flex-col items-center gap-1 bg-lilac-soft px-5 py-6 text-center" data-id="element-198" data-mp="2vtkrsrl5fecx">
            <span className="text-sm font-bold text-plum" style={{
            fontSize: "16px"
          }} data-id="element-199" data-mp="30t7674cpr0nb">
              Real total value: <span className="text-plum/40 line-through" data-id="element-200" data-mp="35r8q1rhyr3zu">$131</span>
            </span>
            <span className="text-grape-shine font-display text-5xl font-black leading-none sm:text-6xl" style={{
            fontSize: "80px",
            fontFamily: "Montserrat, sans-serif",
            paddingTop: "8px",
            paddingBottom: "11px",
            fontWeight: "800"
          }} data-id="element-201" data-mp="3aq35qkkmwcfq">
              $19
            </span>
            <span className="text-xs font-semibold uppercase tracking-wide text-plum/60" data-id="element-202" data-mp="3oirrvv094c0a">
              USD · One-time payment
            </span>
            <span className="mt-1 text-[11px] font-medium text-plum/50" data-id="element-203" data-mp="3ti4bm6vtt2yn">
              Payment will be processed in your local currency.
            </span>
          </div>
        </div>

        <div className="mt-9 flex justify-center" data-id="element-204" data-mp="2g0yw3l90m22">
          <CTAButton data-id="element-205" data-mp="3tnde4d2kmpfc">Get The MenoReset System™</CTAButton>
        </div>

        <p className="mt-3 text-xs font-semibold text-plum/55" data-id="element-206" data-mp="3tnn4i1rj2ylk">
          You save $112 USD (85% OFF) · One-time payment
        </p>
        

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs font-medium text-plum/55" data-id="element-207" data-mp="q6d9jm7vowwc">
          {trust.map(({
          icon: Icon,
          label
        }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-208" data-mp="l9wes966bkaa">
              <Icon className="h-4 w-4 text-grape" data-id="element-209" data-mp="gf0md7x0yuwn" />
              {label}
            </span>)}
        </div>
      </div>
    </section>;
}